import GenericRowEditAndDeleteModal from 'components/icons/GenericRowEditAndDeleteModal';

export const columnsDataCanalVenda = [
	{
		Header: ' ',
		accessor: 'CheckBox',
		disableSortBy: true,
		type: 'checkBox',
		filter: false,
	},
	{
		Header: 'Canal de Venda',
		accessor: 'nome_canal_venda',
		type: 'text',
		optional: true,
		filter: 'includesIgnoreCase',
		hover: 'Nome do canal de venda',
	},
	{
		Header: ' ',
		type: 'jsx',
		accessor: 'button',
		jsx: GenericRowEditAndDeleteModal,
		filter: false,
	},
];
